// node modules
import React from 'react';
import { gql } from '@apollo/client';

// app modules: components
import Layout from 'components/Layout';
import HeadContent from 'components/HeadContent';
import Person from 'components/Person';

const PERSON_QUERY = gql`
  query GetPerson($id: String, $country: String) {
    Person(id: $id) {
      id
      first_name
      last_name
      title
      biography
      avatar_name
      website
      is_author
      facebook
      instagram
      twitter
      spotify
      app_user_id
      book_count
      licensed_book_count
      appears_in_count
      recommendations {
        comment
        ranking
        book {
          alacarte
          alacarte_available(country: $country)
          coming_soon
          isbn
          title
          image_name
          signature_
          indexable
          licensed
          ranking_recommendations
          authors {
            id
            first_name
            last_name
          }
        }
      }
    }
  }
`;

async function action({ client, query, store, isGoogleBot }, params) {
  const { user } = store.getState();
  const { data } = await client.query({
    query: PERSON_QUERY,
    variables: {
      id: params.id,
      country: user.geolocation.countryCode,
    },
  });

  const title = data.Person.title
    ? `${data.Person.first_name} ${data.Person.last_name} - ${data.Person.title}`
    : `${data.Person.first_name} ${data.Person.last_name}`;
  const description = data.Person.biography;

  return {
    chunks: ['person'],
    description,
    navigation: {
      heading: 'Authors',
      section: 'Books',
      left: 'back',
    },
    component: (
      <Layout>
        <HeadContent
          contents={{
            title,
            description,
          }}
        />
        <Person person={data.Person} debug={!!query.debug} forceSsr={isGoogleBot} />
      </Layout>
    ),
  };
}

export default action;
